import { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useStore } from '../../../stores';
import className from './sales.module.scss';

type Tab = 'month' | 'customer' | 'product';

export default observer(function SalesRoute() {
    const { salesStore } = useStore();
    const { byMonth, byCustomer, byProduct, isLoading } = salesStore;
    const [activeTab, setActiveTab] = useState<Tab>('month');

    useEffect(() => {
        salesStore.fetchByMonth();
        salesStore.fetchByCustomer();
        salesStore.fetchByProduct();
    }, []);

    const formatCurrency = (value: number) =>
        new Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(value);

    return (
        <div className={className.base}>
            <div className={className.header}>
                <h1 className={className.title}>Ventas</h1>
            </div>
            <div className={className.tabs}>
                <button className={`${className.tab} ${activeTab === 'month' ? className.active : ''}`} onClick={() => setActiveTab('month')}>Por mes</button>
                <button className={`${className.tab} ${activeTab === 'customer' ? className.active : ''}`} onClick={() => setActiveTab('customer')}>Por cliente</button>
                <button className={`${className.tab} ${activeTab === 'product' ? className.active : ''}`} onClick={() => setActiveTab('product')}>Por producto</button>
            </div>
            {isLoading && <div className={className.loading}>Cargando...</div>}
            {!isLoading && activeTab === 'month' && (
                <div className={className['table-container']}>
                    <table className={className.table}>
                        <thead><tr><th>Mes</th><th className={className.right}>Pedidos</th><th className={className.right}>Total ventas</th></tr></thead>
                        <tbody>
                            {byMonth.map(row => (<tr key={row.month}><td>{row.label}</td><td className={className.right}>{row.count}</td><td className={className.right}>{formatCurrency(row.total)}</td></tr>))}
                            {byMonth.length === 0 && <tr><td colSpan={3} className={className.empty}>Sin datos aún</td></tr>}
                        </tbody>
                    </table>
                </div>
            )}
            {!isLoading && activeTab === 'customer' && (
                <div className={className['table-container']}>
                    <table className={className.table}>
                        <thead><tr><th>#</th><th>Cliente</th><th>Email</th><th className={className.right}>Pedidos</th><th className={className.right}>Total comprado</th></tr></thead>
                        <tbody>
                            {byCustomer.map((row, index) => (<tr key={row.email}><td className={className.rank}>{index + 1}</td><td>{row.name || '—'}</td><td className={className.email}>{row.email}</td><td className={className.right}>{row.order_count}</td><td className={className.right}>{formatCurrency(row.total)}</td></tr>))}
                            {byCustomer.length === 0 && <tr><td colSpan={5} className={className.empty}>Sin datos aún</td></tr>}
                        </tbody>
                    </table>
                </div>
            )}
            {!isLoading && activeTab === 'product' && (
                <div className={className['table-container']}>
                    <table className={className.table}>
                        <thead><tr><th>#</th><th>Producto</th><th className={className.right}>Unidades vendidas</th><th className={className.right}>En pedidos</th></tr></thead>
                        <tbody>
                            {byProduct.map((row, index) => (<tr key={row.name}><td className={className.rank}>{index + 1}</td><td>{row.name}</td><td className={className.right}>{row.quantity}</td><td className={className.right}>{row.order_count}</td></tr>))}
                            {byProduct.length === 0 && <tr><td colSpan={4} className={className.empty}>Sin datos aún</td></tr>}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
});